
import React from "react";
import { Navigate } from "react-router-dom";
import { useAccess } from "../Component/AccessContext";

const PrivateRoute = ({ children }) => {
  const accessContext = useAccess();
const hasAccess = accessContext?.hasAccess;

  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
